import React from "react";
import trash from "./trash.svg";
import { Button } from "@material-ui/core";
function Trash(props) {
  return (
    <React.Fragment>
      <button
        style={{
          backgroundColor: "transparent",
          borderBlockColor: "none",
          border: "none",
          elevation: 0,
          width: 22,
          height: 22,
          cursor: "pointer",
          padding: 3,
        }}
        onClick={props.onClick}
      >
        <img src={trash} alt="Logo" />
      </button>
    </React.Fragment>
  );
}

export default Trash;
